import { useCallback } from 'react';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { CHOOSE_ACCOUNT_PATH } from 'src/commons/constants';

export const useInterstitialModalIntercept = () => {
  const {
    setInterstitialDestinationUrl,
    setInterstitialAppName,
    showInterstitialModal,
  } = useConsolidatedNavContext();

  return useCallback(
    (
      url: string | undefined,
      appName: string | undefined,
      event?: React.SyntheticEvent,
    ): boolean => {
      if (!showInterstitialModal || !url?.includes(CHOOSE_ACCOUNT_PATH)) {
        return false;
      }
      event?.preventDefault();
      setInterstitialDestinationUrl(url);
      setInterstitialAppName(appName ?? '');
      return true;
    },
    [showInterstitialModal],
  );
};
